enum ActionTypes {
  RESET_PRESENCE_INFO = "app/presence/RESET_PRESENCE_INFO",
  SET_LIVE_USERS = "app/presence/SET_LIVE_USERS",
  SET_PRESENCE_INFO = "app/presence/SET_PRESENCE_INFO",
  SET_USERS_PER_SPACE = "app/presence/SET_USERS_PER_SPACE",
}

export default ActionTypes;
